import createSagaMiddleware from "redux-saga";
import {fork} from "redux-saga/effects";
import {applyMiddleware, createStore} from "redux";

import reducers from "./reducers/root";
import fetchPackageSaga from './sagas/fetch-package';
import fetchDocSaga from './sagas/fetch-doc';
import listPackagesSaga from './sagas/list-packages';
import listDocsSaga from './sagas/list-docs';

const sagaMiddleware = createSagaMiddleware();
const store = createStore( reducers, applyMiddleware( sagaMiddleware ) );
const sagas = [ fetchPackageSaga, listPackagesSaga, fetchDocSaga, listDocsSaga ];


const rootSaga = function* ()
{
    yield sagas.map( saga => fork( saga ) );
};

sagaMiddleware.run( rootSaga );


export { store, sagaMiddleware };



// WEBPACK FOOTER //
// ./src/lib/store.js